import PchPurchaseInvoice from '@/models/Purchase/PchPurchaseInvoice'
//
export default async data => {
    try {
        let invoice = new PchPurchaseInvoice(data)
        let response = await invoice.save()
        return response
    } catch (error) {
        return error.response
    }
}
